var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "component-root" },
    [
      _c("h1", [
        _vm._v(_vm._s(_vm.resource("JourneyBuilder_JourneyReport_Title")))
      ]),
      _vm._v(" "),
      _c("div", [_c("navigate-to-overview-button")], 1),
      _vm._v(" "),
      _c("configurable-sankey-v2")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }